import { render } from "./EditLead.vue?vue&type=template&id=3c04d7c6&lang=pug"
import script from "./EditLead.vue?vue&type=script&lang=js"
export * from "./EditLead.vue?vue&type=script&lang=js"

import "./EditLead.vue?vue&type=style&index=0&id=3c04d7c6&lang=scss"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__